import { Text } from '@/components/ui/text';
import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Linking, Pressable, View } from 'react-native';

export function LocationDeniedPrompt() {
  return (
    <View className="flex-1 items-center justify-center px-8 py-16">
      <Ionicons name="location-outline" size={48} className="text-muted-foreground mb-4" />
      <Text className="text-xl font-semibold text-center mb-2 text-foreground">
        Location access needed
      </Text>
      <Text className="text-center mb-6 text-muted-foreground">
        Enable location to see posts from nearby restaurants.
      </Text>
      <Pressable
        onPress={() => Linking.openSettings()}
        accessibilityRole="button"
        className="px-6 py-3 rounded-lg bg-surface-secondary"
      >
        <Text className="font-semibold text-secondary-foreground">
          Open Settings
        </Text>
      </Pressable>
    </View>
  );
}
